<template>
  <div class="cc-app-store-links">
    <v-btn
      class="cc-app-store-links__button"
      variant="outlined"
      :color="color"
      :size="size"
      :href="AppStores.IOS"
      target="_blank"
      rel="noopener"
      :prepend-icon="Icons.APPLE"
      :append-icon="Icons.OPEN_IN_NEW"
    >
      {{ t('appPromo.stores.ios') }}
    </v-btn>
    <v-btn
      class="cc-app-store-links__button"
      variant="outlined"
      :color="color"
      :size="size"
      :href="AppStores.ANDROID"
      target="_blank"
      rel="noopener"
      :prepend-icon="Icons.GOOGLE_PLAY"
      :append-icon="Icons.OPEN_IN_NEW"
    >
      {{ t('appPromo.stores.android') }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
//================= [CSS] =====================================

//================= [JS] ======================================
import {AppStores} from '@/common/enums/AppStores';
import {Icons} from '@simpleforyou/client-core';
//================= [VUE COMPONENTS] ==========================
import {useI18n} from 'vue-i18n';

// Both places that offer the app use this: the one-off dialog and the footer.
// They differ only in how loud they are, which is what the two props carry.
withDefaults(defineProps<{size?: string, color?: string}>(), {
  size: 'large',
  color: 'primary',
});

const {t} = useI18n();
</script>

<style scoped lang="scss">
.cc-app-store-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.cc-app-store-links__button {
  flex: 0 1 auto;
}
</style>
